import Component from './Refresh.vue';

export default {
  install(Vue) {
    Vue.component('BkfActionRefresh', Component);
  },
};
